<template>
    <div>
        <a-spin :spinning="tableRelevant.tableLoading" id="StepsSecond">
            <div class="left hideScroll">
                <a-tree
                    :checkedKeys="tree.checkedKeys"
                    defaultExpandAll
                    :key="tree.key"
                    checkable
                    checkStrictly
                    @check="treeCheck"
                    @select="treeCheck"
                    :replaceFields="{title:'name', key:'id'}"
                    :tree-data="tree.treeAllData">
                    <span slot="title" slot-scope="value">
                        {{value.name}}
                        （{{value.selectStuNum + value.add.length - value.del.length}}
                        / {{value.userCount}}）
                    </span>
                </a-tree>
            </div>
            <div class="right hideScroll">
                <a-form-model layout="inline" :model="searchForm" style="margin-bottom: 15px;">
                    <a-form-model-item label="学生姓名">
                        <a-input class="serach-item" :maxLength="30" allowClear v-model="searchForm.userName"
                                placeholder="请输入学生姓名"/>
                    </a-form-model-item>
                    <a-form-model-item label="课程数量">
                        <a-input class="serach-item" :maxLength="30" allowClear v-model="searchForm.courseCount"
                                placeholder="请输入课程数量"/>
                    </a-form-model-item>
                    <a-form-model-item style="margin-right: 35px;">
                        <a-button @click="getStudentsData(1)" type="primary" html-type="button">
                            查询
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
                <a-table :columns="columns"
                        :row-key="text => text.organizationUserId"
                        :row-selection="tableRowSelection"
                        :pagination="tableRelevant.tablePagination"
                        :dataSource="tableRelevant.tableDataSource">
                        <div slot="classNames" slot-scope="text, record">
                            {{text.gradeName}}{{text.className}}
                        </div>
                        <div slot="gender" slot-scope="text, record">
                            {{text.gender == 0 ? '女' : '男'}}
                        </div>
                        <div slot="birthday" slot-scope="text, record">
                            {{text.birthday.split(' ')[0]}}
                        </div>
                        <div slot="courseName" slot-scope="text, record">
                            <div class="self_td" v-for="item in text.userCourses" :key="item.id">{{item.projectCourseConfigName}}</div>
                        </div>
                        <div slot="progress" slot-scope="text, record">
                            <div class="self_td" v-for="item in text.userCourses" :key="item.id">{{item.progress}}%</div>
                        </div>
                        <div slot="status" slot-scope="text, record">
                            <div class="self_td" v-for="item in text.userCourses" :key="item.id">
                                {{item.progress == 0 ? '未开始' : item.progress == 100 ? '已完成' : '进行中'}}
                            </div>
                        </div>
                </a-table>
                <!-- <div v-if="!IsDetails" style="text-align: right;margin: 30px 0;padding-right: 50px;">
                    <a-button @click="$parent.$data.current = 1" style="margin-right: 20px;">上一步 修改所选课程</a-button>
                    <a-button type="primary" :loading="formRelevant.loading" @click="next">下一步 保存并退出</a-button>
                </div> -->
                <div style="text-align: right;margin: 30px 0;padding-right: 50px;">
                    <a-button @click="$parent.$data.current = 1" style="margin-right: 20px;">上一步 修改所选课程</a-button>
                    <a-button type="primary" :loading="formRelevant.loading" @click="next">下一步 保存并退出</a-button>
                </div>
            </div>
        </a-spin>
    </div>
</template>

<script>
    import { tableRelevant, FormatDate, ArrayUnique2 } from '@/pages/projectImpl/js/utils'
    import $Bus from "@/pages/projectImpl/js/eventBus";
    const columns = [
        { title: '学生', dataIndex: 'realName' },
        { title: '班级', scopedSlots: {customRender: 'classNames'}},
        { title: '性别', scopedSlots: {customRender: 'gender'}},
        { title: '出生日期', scopedSlots: {customRender: 'birthday'}},
        { title: '课程名称',class:'testClass', scopedSlots: {customRender: 'courseName'}},
        { title: '个人进度',class:'testClass', scopedSlots: {customRender: 'progress'}},
        { title: '个人状态',class:'testClass', scopedSlots: {customRender: 'status'}},
    ]

    export default {
        name: "StepsThird",
        props: {
            IsDetails: false
        },
        data() {
            return {
                //当前报告信息
                reportInfo: this.$store.getters['organization/getReportInfo'],
                formRelevant: {
                    loading: false,
                },

                organizationId: this.$store.getters['organization/getReportInfo'].organizationId,
                courseInfo: this.$store.getters["course/getEditCourse"](),
                searchForm: {
                    userName: '',
                    courseCount: '',
                    gradeId: undefined,
                    classId: undefined,
                    projectCourseConfigId: this.$store.getters["course/getEditCourse"]().id
                },
                columns,
                //表格相关
                tableRelevant: tableRelevant.call(this),
                //树相关
                tree: {
                    key: Date.now(),
                    treeData: [],
                    treeAllData: [],
                    checkedKeys: { //树结构全选与半选
                        checked: [],
                        halfChecked: []
                    },
                    selectedRowKeys: [], // 学生列表选中
                    selectRows:[],
                    treeDataChecked: undefined, // 树结构选中状态缓存
                    treeDataValue: {}, // 树结构选中数据缓存
                    selectStudentNumber: 0, //选中学生的数量统计
                    surplusStudentNumber: 0, //剩余学生的数量统计
                    addOrganizationUserIds: [], //新增学生的id
                    deleteOrganizationUserIds: [] //删除学生的id
                }
            }
        },
        computed: {
            tableRowSelection() {
                const that = this
                return {
                    selectedRowKeys: that.tree.selectedRowKeys,
                    onSelect(record, selected) {
                        const indexOf = that.tree.selectedRowKeys.indexOf(record.organizationUserId)
                        const indexOfRow = that.tree.selectRows.findIndex(item=>record.organizationUserId ==item.organizationUserId)
                        if (selected) {
                            if (indexOf === -1) {
                                that.tree.selectedRowKeys.push(record.organizationUserId)
                                that.tree.selectRows.push(record)
                            }
                        } else {
                            if (indexOf !== -1) {
                                that.tree.selectedRowKeys.splice(indexOf, 1)
                                that.tree.selectRows.splice(indexOfRow,1)
                            }
                        }
                        that.selectTree(record.classId)
                    },
                    onSelectAll(selected, selectedRows, changeRows) {
                        if (selected) {
                            changeRows.forEach(f => {
                                if (!that.tree.selectedRowKeys.includes(f.organizationUserId)) {
                                    that.tree.selectedRowKeys.push(f.organizationUserId)
                                    that.tree.selectRows.push(f)
                                    that.selectTree(f.classId)
                                }
                            })
                        } else {
                            changeRows.forEach(f => {
                                if (f.hasTested) {
                                    return
                                }
                                const indexOf = that.tree.selectedRowKeys.indexOf(f.organizationUserId)
                                const indexOfRow = that.tree.selectRows.findIndex(item=>f.organizationUserId ==item.organizationUserId)
                                if (indexOf !== -1) {
                                    that.tree.selectedRowKeys.splice(indexOf, 1)
                                     that.tree.selectRows.splice(indexOfRow, 1)
                                    that.selectTree(f.classId)
                                }
                            })
                        }
                    }
                }
            }
        },
        mounted() {
            this.getTreeData()
        },
        methods: {
            //如果是第三步返回，就初始化页面之前选中
            initPageData() {
                if (this.courseInfo.tree) {
                    this.tree = JSON.parse(JSON.stringify(this.courseInfo.tree))
                }
            },
            //获取左侧树结构数据
            getTreeData() {
                const params = {
                    extendId:this.$store.getters['organization/getReportInfo'].id,
                    organizationId: this.$store.getters['organization/getReportInfo'].organizationId,
                    ProjectCourseConfigIds:this.$store.getters['organization/getReportCourse'],
                }
                this.tableRelevant.tableLoading = true
                this.$http.GroupReport.projectcoursegradeclasstree(params).then(res => {
                    this.tree.key = Date.now()
                    this.tree.treeData = res.data.filter(f => f.level == 1).map(m => {
                        return {
                            ...m,
                            add: [],
                            del: [],
                            scopedSlots: { title: 'title' },
                            children: res.data.filter(f => f.level == 2 && f.parentId == m.id).map(m1 => ({
                                ...m1,
                                add: [],
                                del: [],
                                scopedSlots: { title: 'title' }
                            }))
                        }
                    })
                    this.tree.treeAllData = res.data.filter(f => f.level === 0).map(m => {
                        return {
                            ...m,
                            name: '全部',
                            add: [],
                            del: [],
                            scopedSlots: { title: 'title' },
                            children: this.tree.treeData
                        }
                    })
                    try {
                        this.searchForm.gradeId = ''
                        this.searchForm.classId = ''
                    } catch (e) {
                        console.log(e)
                    }
                    this.initPageData()
                    this.getStudentsData('tree', this.tree.treeData[0])
                    if(this.reportInfo.status == 0 || this.reportInfo.status == undefined){
                        this.getStudentsData(true, this.tree.treeAllData[0])
                    }

                }).finally(() => {
                  this.tableRelevant.tableLoading = false
                })
            },
            //获取右侧学生列表数据
            getStudentsData(checked, json) {
                let params = {
                    organizationId: this.$store.getters['organization/getReportInfo'].organizationId,
                    ProjectCourseConfigIds:this.$store.getters['organization/getReportCourse'],
                    ReportConfigId:this.reportInfo.id,
                    pageIndex: 1,
                    pageSize: 99999,
                    ...this.searchForm
                }

                this.tableRelevant.tableLoading = true
                this.$http.GroupReport.GetPersonalCombinationReportUserPageList(params).then(res => {
                    this.tableRelevant.tableDataSource = res.data.items
                    if (typeof json === 'object') {
                        this.tree.treeDataValue = json
                    }
                    this.tableChecked(checked)
                    if (typeof checked === 'boolean') {
                        this.selectTree()
                    } else {
                        this.treeCheckedStyle()
                    }
                }).finally(() => {
                  this.tableRelevant.tableLoading = false
                })
            },
            //树复选框选中或取消
            treeCheck(checkedKeys, e) {
                const value = e.node.dataRef
                switch (value.level) {
                    case 1:
                        this.searchForm.classId = undefined
                        this.searchForm.gradeId = value.id
                        break

                    case 2:
                        this.searchForm.classId = value.id
                        this.searchForm.gradeId = value.parentId
                        break

                    default:
                        this.searchForm.classId = undefined
                        this.searchForm.gradeId = undefined
                        break
                }

                this.getStudentsData(e.checked, value)

                //手动添加树结构选中状态
                const li = document.querySelectorAll('.left .ant-tree-node-content-wrapper')
                for (let i = 0; i < li.length; i++) {
                    li[i].classList.remove('ant-tree-node-selected')
                }
                e.node.$el.querySelector('.ant-tree-node-content-wrapper').classList.add('ant-tree-node-selected')
            },
            //页面表格初始化选中
            tableChecked(checked) {
                if (typeof this.tree.treeDataValue !== "object") {
                    return
                }
                if (typeof checked !== 'boolean') {
                    this.tableRelevant.tableDataSource.forEach(f => {
                        if (!(this.tree.treeDataValue.add.length || this.tree.treeDataValue.del.length)) {
                            if (f.isSelect && !this.tree.selectedRowKeys.includes(f.organizationUserId)) {
                                this.tree.selectedRowKeys.push(f.organizationUserId)
                                this.tree.selectRows.push(f)
                            }
                        }
                    })
                } else {
                    this.tableRelevant.tableDataSource.forEach(f => {
                        if (!f.hasTested) {
                            const index = this.tree.selectedRowKeys.indexOf(f.organizationUserId)
                            const indexOfRow = this.tree.selectRows.findIndex(item=>f.organizationUserId ==item.organizationUserId)
                            if (checked) {
                                if (index === -1) {
                                    this.tree.selectedRowKeys.push(f.organizationUserId)
                                    this.tree.selectRows.push(f)
                                }
                            } else {
                                if (index !== -1){
                                     this.tree.selectedRowKeys.splice(index, 1)
                                     this.tree.selectRows.splice(indexOfRow, 1)
                                }
                            }
                        }
                    })
                }
            },

            //树结构全选和半选
            treeCheckedStyle() {
                /**
                 * 设置树结构全选半选样式
                 * @param data
                 */
                const setTreeStyle = (data) => {
                    const checked = this.tree.checkedKeys.checked.indexOf(data.id)
                    const halfChecked = this.tree.checkedKeys.halfChecked.indexOf(data.id)
                    const selectNumber = data.selectStuNum + data.add.length - data.del.length

                    if (data.userCount === selectNumber && selectNumber > 0) {
                        if (checked === -1) {
                            this.tree.checkedKeys.checked.push(data.id)
                            if (halfChecked > -1) {
                                this.tree.checkedKeys.halfChecked.splice(halfChecked, 1)
                            }
                        }
                    } else if (selectNumber > 0 && data.userCount > selectNumber) {
                        if (halfChecked === -1) {
                            this.tree.checkedKeys.halfChecked.push(data.id)
                            if (checked > -1) {
                                this.tree.checkedKeys.checked.splice(checked, 1)
                            }
                        }
                    } else {
                        if (checked > -1) {
                            this.tree.checkedKeys.checked.splice(checked, 1)
                        }
                        if (halfChecked > -1) {
                            this.tree.checkedKeys.halfChecked.splice(halfChecked, 1)
                        }
                    }
                }

                const selectData = (arr, level) => {
                    arr.forEach(f => {
                        if (f.level === level) {
                            let add = [], del = []
                            f.children.forEach(f1 => {
                                add = add.concat(f1.add)
                                del = del.concat(f1.del)
                                setTreeStyle(f1)
                            })
                            f.add = add
                            f.del = del
                            setTreeStyle(f)
                        }
                        if (f.children && f.children.length) {
                            selectData(f.children, level)
                        }
                    })
                }
                selectData(this.tree.treeAllData, 1)
                selectData(this.tree.treeAllData, 0)
                //选中学生数量统计
                const addNumber = this.tree.treeAllData[0].add.filter((f, i) => this.tree.treeAllData[0].add.indexOf(f) === i)
                const delNumber = this.tree.treeAllData[0].del.filter((f, i) => this.tree.treeAllData[0].del.indexOf(f) === i)
                this.tree.selectStudentNumber = this.tree.treeAllData[0].userIds.length + addNumber.length - delNumber.length
            },

            /**
             * 树结构选中及学生选中数量监听
             * @param id 可选  班级的id
             */
            selectTree(id) {
                //树复选框新增或删除了哪些学生
                const treeAddOrDelStudent = (data) => {
                    this.tableRelevant.tableDataSource.forEach(item => {
                        if (data.id === item.classId) {
                            const addIndex = data.add.indexOf(item.organizationUserId )
                            const delIndex = data.del.indexOf(item.organizationUserId )
                            if (this.tree.selectedRowKeys.includes(item.organizationUserId)) {
                                if (!item.isSelect) {
                                    if (addIndex === -1) data.add.push(item.organizationUserId )
                                } else {
                                    if (delIndex !== -1) data.del.splice(delIndex, 1)
                                }
                            } else {
                                if (!item.isSelect) {
                                    if (addIndex !== -1) data.add.splice(addIndex, 1)
                                } else {
                                    if (delIndex === -1) data.del.push(item.organizationUserId )
                                }
                            }
                        }
                    })
                }

                let json = this.tree.treeDataValue

                function setJson(arr, iid, type) {
                    for (let i = 0; i < arr.length; i++) {
                        if (type && iid === arr[i].id) {
                            json = arr[i]
                            return
                        }
                        if (!type) {
                            treeAddOrDelStudent(arr[i])
                        }
                        if (arr[i].children && arr[i].children.length) {
                            setJson(arr[i].children, iid, type)
                        }
                    }
                }

                if (id) {
                    setJson(this.tree.treeData, id, true)
                    // this.tree.treeData.forEach(f => {
                    //     if (f.children && f.children.length) {
                    //         for (let i = 0; i < f.children.length; i++) {
                    //             if (id === f.children[i].id) {
                    //                 json = f.children[i]
                    //             }
                    //         }
                    //     }
                    // })
                }
                switch (json.level) {
                    case 1:
                        if (json.children && json.children.length) {
                            json.children.forEach(f => {
                                treeAddOrDelStudent(f)
                            })
                        }
                        break
                    case 2:
                        treeAddOrDelStudent(json)
                        break
                    default:
                        setJson(this.tree.treeData)
                }

                this.treeCheckedStyle()
            },

            // 下一步
            next() {
                if(!this.tree.selectedRowKeys.length){
                    this.$message.destroy()
                    this.$message.warn('请选择学生')
                    return
                }
                const params = []
                console.log(this.tree.selectRows);
                this.tree.selectRows.forEach((item, index) => {
                     params.push({
                      "reportConfigId": this.reportInfo.id,
                      "organizationUserId": item.organizationUserId,
                      "classUserId": item.classUserId
                      })
                })

                this.formRelevant.loading = true
                this.$http.GroupReport.editPersonalStudent(params)
                .then(res => {
                    this.generateReport()
                }).finally(() => {
                  this.formRelevant.loading = false;
                })
            },
            generateReport(){
                this.$http.GroupReport.generateReport({
                    id:this.reportInfo.id
                })
                .then(res => {
                    this.formRelevant.loading = false;
                     this.$message.success("操作成功");
                    $Bus.$emit("closeCreateReport");

                });
            },
        }
    }
</script>

<style scoped>

#StepsSecond, #StepsSecond >>> .ant-spin-container {
        height: 100%;
    }

    .hideScroll {
        height: 100%;
        overflow-y: auto;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
    }

    .hideScroll::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }

    #StepsSecond >>> > .ant-spin-container {
        display: flex;
    }

    #StepsSecond .left {
        width: 260px;
        flex-shrink: 0;
        margin-right: 20px;
        border-right: 1px solid #ddd;
    }

    #StepsSecond .right {
        flex-grow: 1;
    }

    .ant-btn-link {
        margin-right: 15px;
    }

    .disabled {
        pointer-events: none;
    }
    /deep/ .ant-table-tbody .testClass{
        padding: 0 !important;
    }
    .self_td{
        height: 54px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        /* justify-content: center; */
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
